import request from '@/request'

/**
 * 获取小程序列表
 * @param params
 * @returns {AxiosPromise}
 */
export function list(params) {
  const url = '/api/v1/program/list'
  return request({ url, method: 'get', params: params })
}

export function modify(data) {
  return request({
    url: '/api/v1/program/modify',
    method: 'POST',
    data: data,
  })
}

/**
 * 获取小程序详情
 * @param params
 * @returns {AxiosPromise}
 */
export function get_detail(params) {
  const url = '/api/v1/program/detail'
  return request({ url, method: 'GET', params })
}

/**
 * 修改页面状态
 * @param params
 * @returns {AxiosPromise}
 */
export function upd_program_page(data) {
  return request({
    url: '/api/v1/program/upd_page',
    method: 'POST',
    data: data,
  })
}

/**
 * 删除推广页面
 * @param data
 * @returns {AxiosPromise}
 */
export function delete_program_page(data) {
  return request({
    url: '/api/v1/program/delete_page',
    method: 'POST',
    data: data,
  })
}

/**
 * 小程序的推广量图表
 * @returns {AxiosPromise}
 */
export function getProgramData(params) {
  return request({
    url: '/api/v1/get_program_data',
    method: 'get',
    params: params,
  })
}

/**
 * 小程序的推广量 top 10 人员
 * @returns {AxiosPromise}
 */
export function getProgramTop(params) {
  return request({
    url: '/api/v1/get_program_top',
    method: 'get',
    params: params,
  })
}

/**
 * 获取活动成员
 * @param params
 * @returns {AxiosPromise}
 */
export function getActiveMember(params) {
  return request({
    url: '/api/v1/program/get_active_member',
    method: 'GET',
    params: params,
  })
}

/**
 * 添加 小程序 成员(添加平台成员)
 * @param data
 * @returns {AxiosPromise}
 */
export function add_active_member(data) {
  return request({
    url: '/api/v1/program/active_member',
    method: 'POST',
    data: data,
  })
}

/**
 * 移除推广员
 * @param data
 * @returns {AxiosPromise}
 */
export function removeQrCode(data) {
  return request({
    url: '/api/v1/program/remove_qr',
    method: 'POST',
    data: data,
  })
}

/**
 * 批量生成二维码
 * @param data
 * @returns {AxiosPromise}
 */
export function create_qr(data) {
  return request({
    url: '/api/v1/program/create_qr',
    method: 'POST',
    data: data,
    timeout: 20000,
  })
}

/**
 * 获取小程序推广收集的手机号列表
 * @returns {AxiosPromise}
 * @param data
 */
export function get_collection(data) {
  return request({
    url: '/api/v1/program/collection',
    method: 'POST',
    data: data,
  })
}

/**
 * 获取小程序推广收集的全部手机号列表
 * @param params
 * @returns {AxiosPromise}
 */
export function export_excel(params) {
  return request({
    url: '/api/v1/program/export_excel',
    responseType: 'blob',
    timeout: 60000,
    method: 'GET',
    params: params,
  })
}

/**
 * 推送数据到 CRM
 * @param data
 * @returns {AxiosPromise}
 */
export function pushDataToCrm(data) {
  return request({
    url: '/api/v1/push_data_to_crm',
    method: 'post',
    data: data,
  })
}

/**
 * 批量推送数据到 CRM
 * @param data
 * @returns {AxiosPromise}
 */
export function patchPushDataToCrm(data) {
  return request({
    url: '/api/v1/patch_push_data_to_crm',
    method: 'post',
    data: data,
  })
}
/**
 * 添加小程序推广页面
 * @param data
 * @returns {AxiosPromise}
 */
export function addPromotionPage(data) {
  return request({
    url: '/api/v1/add_promotion_page',
    method: 'post',
    data: data,
  })
}

/**
 * 小程序推广页面
 * @param data
 * @returns {AxiosPromise}
 */
export function getPromotionPage(data) {
  return request({
    url: '/api/v1/program/get_promotion_page',
    method: 'POST',
    data: data,
  })
}

/**
 * 下载我的二维码的列表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportQr(data) {
  return request({
    url: '/api/v1/export_qr',
    responseType: 'blob',
    method: 'post',
    data: data,
    timeout: 20000,
  })
}
